import { usePropertyField } from '../usePropertyField';
import { IApplicationNonRental } from '@apply/api/src/api/ApplyApi';

// ─── NonRental – Onsite Contact ───────────────────────────────────────────────

export const usePropertyContactIsPrimary = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.contactIsPrimary,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), contactIsPrimary: v } as IApplicationNonRental }));

export const usePropertyContactFirstName = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.contactName?.first,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), contactName: { ...(p.nonRental?.contactName ?? {}), first: v } } as IApplicationNonRental }));

export const usePropertyContactMiddleName = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.contactName?.middle,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), contactName: { ...(p.nonRental?.contactName ?? {}), middle: v } } as IApplicationNonRental }));

export const usePropertyContactLastName = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.contactName?.last,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), contactName: { ...(p.nonRental?.contactName ?? {}), last: v } } as IApplicationNonRental }));

export const usePropertyContactPhone = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.phone,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), phone: v } as IApplicationNonRental }));

export const usePropertyContactEmail = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.email,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), email: v } as IApplicationNonRental }));

export const usePropertyContactName = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.name as string,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), name: v } as IApplicationNonRental }));
